export default "__VITE_ASSET__ByeFS8UK__"